<template>
  <BaseTopNavigation
    v-bind="$attrs"
    v-on="$listeners"
    :styleConfig="styleConfig"
  >
    <template v-slot:left>
      <slot name="left" />
    </template>
    <template v-slot:right>
      <slot name="right" />
    </template>
  </BaseTopNavigation>
</template>

<script>
  import BaseTopNavigation from '@base/v2/base-top-navigation'
  import { Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'TopNavigationSecondary',
    inheritAttrs: false,
    components: {
      BaseTopNavigation,
    },
    data: function () {
      return {
        styleConfig: {
          container: {
            height: '64px',
            padding: `0 ${Layout.space.lg}`,
            width: '100%',
          },
          left: {
            alignItems: 'center',
            display: 'flex',
            height: '100%',
            justifyContent: 'flex-start',
          },
          right: {
            alignItems: 'center',
            display: 'flex',
            flex: 1,
            height: '100%',
            justifyContent: 'flex-end',
            width: 'calc(100% - 48px)',
          },
        },
      };
    },
    created: function () {
      Object.assign(
        this.styleConfig.container,
        {
          backgroundColor: this.color.background1(),
        },
      );
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
  };
</script>
